module.exports = __webpack_public_path__ + "img/clientes_home.10cfc8f8.jpg";